import React from 'react';
import { Box } from '@chakra-ui/react';
import RegisterForm from '../components/auth/RegisterForm';
import HeatZoneBackground from '../components/common/HeatZoneBackground';

export const RegisterPage = () => {
  return (
    <Box minH="100vh" position="relative" overflow="hidden">
      <HeatZoneBackground />
      <Box position="relative" zIndex={10} py={10}>
        <RegisterForm />
      </Box>
    </Box>
  );
};

export default RegisterPage;
